import Layout from '@/layouts/Layout'

const home = {
  path: '/finance',
  component: Layout,
  name: 'finance',
  meta: {
    title: '财务管理',
  },
  children: [
    {
      path: '/finance/groupDashboard/list',
      name: 'tenant_finance_board',
      component: () => import('@/pages/finance/financeDashboard/group/list'),
      meta: { title: '财务看板（集团）', logEvent: '' },
    },
    {
      path: '/finance/companyDashboard/list',
      name: 'company_finance_board',
      component: () => import('@/pages/finance/financeDashboard/company/list'),
      meta: { title: '财务看板（公司）', logEvent: '' },
    },
    {
      path: '/finance/collection',
      name: 'financeCollection',
      component: () => import('@/pages/finance/collection/index'),
      meta: { title: '应收管理', logEvent: '' },
    },
    {
      path: '/finance/batchAmountRemission',
      name: 'batchAmountRemission',
      hidden: true,
      component: () => import('@/pages/finance/batchAmountRemission/index'),
      meta: {
        title: '批量金额减免',
        logEvent: '',
        parent: [
          {
            path: '/finance/collection',
            name: 'financeCollection',
            title: '应收管理',
          },
        ],
      },
    },
    {
      path: '/finance/collection/batchReceivableChange',
      name: 'changeReceivableImport',
      component: () => import('@/pages/finance/batchReceivableChange'),
      meta: {
        title: '应收批量调整',
        logEvent: '',
        parent: [
          {
            path: '/finance/collection',
            name: 'financeCollection',
            title: '应收管理',
          },
        ],
      },
      hidden: true,
    },
    {
      path: '/finance/collection/detail',
      name: 'finance_receivable_detail',
      component: () => import('@/pages/finance/collectionDetail'),
      meta: { title: '应收详情', logEvent: '' },
      hidden: true,
    },
    {
      path: '/finance/receiptList',
      name: 'financeReceiptList',
      component: () => import('@/pages/finance/receiptList/index'),
      meta: { title: '收款单管理', logEvent: '' },
    },
    {
      path: '/finance/receiptList/detail',
      name: 'finance_receivable_receipt_detail',
      component: () => import('@/pages/finance/receiptDetail'),
      meta: { title: '收款单详情', logEvent: '' },
    },
    {
      path: '/finance/refundList',
      name: 'financeRefundList',
      component: () => import('@/pages/finance/refundList/index'),
      meta: { title: '退款单管理', logEvent: '' },
    },
    {
      path: '/finance/payable',
      name: 'financePayable',
      component: () => import('@/pages/finance/payable'),
      meta: { title: '应付管理', logEvent: '' },
    },
    {
      path: '/finance/payable/detail',
      name: 'finance_payment_detail',
      component: () => import('@/pages/finance/payableDetail'),
      meta: { title: '应付详情', logEvent: '' },
    },
    {
      path: '/finance/payList',
      name: 'financePayList',
      component: () => import('@/pages/finance/payList'),
      meta: { title: '付款单管理', logEvent: '' },
    },
    {
      path: '/finance/payList/detail',
      name: 'finance_payment_bill_detail',
      component: () => import('@/pages/finance/payListDetail'),
      meta: { title: '付款单详情', logEvent: '' },
    },
    {
      path: '/finance/batchPaymentRecord',
      name: 'batchPaymentRecord',
      component: () => import('@/pages/finance/batchPaymentRecord'),
      meta: { title: '批量付款记录', logEvent: '' },
    },
    {
      path: '/finance/withholdingConfig',
      name: 'withholdingConfigNew',
      component: () => import('@/pages/finance/walletWithholdConfig/index'),
      meta: { title: '钱包代扣配置', logEvent: '', keepAlive: false },
    },
    {
      path: '/finance/withholdingConfig/bindBankCard',
      name: 'bindBankCard',
      component: () =>
        import('@/pages/finance/walletWithholdConfig/bindBankCard/index.vue'),
      meta: { title: '绑定银行卡', logEvent: '' },
    },
    {
      path: '/finance/withholdingConfig/replaceBankCard',
      name: 'replaceBankCard',
      component: () =>
        import('@/pages/finance/walletWithholdConfig/bindBankCard/index.vue'),
      meta: { title: '更换银行卡', logEvent: '' },
    },
    {
      path: '/finance/partnerAccountOpen',
      name: 'partnerAccountOpen',
      component: () => import('@/pages/finance/partnerAccountOpen'),
      meta: { title: '合作方账户开通', logEvent: '', keepAlive: false },
    },
    {
      path: '/finance/alipayWithholdConfig',
      name: 'alipayWithholdConfig',
      component: () => import('@/pages/finance/alipayWithholdConfig'),
      meta: { title: '支付宝代扣', logEvent: '', keepAlive: false },
    },
    {
      path: '/finance/transferRulesConfig',
      name: 'transferRulesConfig',
      component: () => import('@/pages/finance/transferRulesConfig'),
      meta: { title: '转账规则配置', logEvent: '', keepAlive: false },
    },
    {
      path: '/finance/transactionDetail',
      name: 'transactionDetail',
      component: () => import('@/pages/finance/transactionDetail'),
      meta: { title: '交易明细对账单', logEvent: '', keepAlive: false },
    },
    {
      path: '/finance/batchPaymentRecord/batchPaymentRecordDetails',
      name: 'finance_batch_payment_record_detail',
      component: () => import('@/pages/finance/batchPaymentRecordDetails'),
      meta: { title: '批量付款详情', logEvent: '' },
      hidden: true,
    },
    {
      path: '/finance/batchCollectionRecord',
      name: 'batchCollectionRecord',
      component: () => import('@/pages/finance/batchCollectionRecord/index'),
      meta: { title: '批量收款记录', logEvent: '' },
    },
    // 新增收款 table前端计算  僵尸代码 目测该功能已经下线
    {
      path: '/finance/AddCollection',
      name: 'finance_batch_receivable_record_add',
      hidden: true,
      component: () => import('@/pages/finance/AddCollection'),
      meta: {
        title: '新增收款',
        logEvent: '',
        parent: {
          path: '/underLease/overdue/detailList',
          name: 'under_lease_over_due_hasten_debt',
          title: '催租明细列表',
        },
      },
    },
    // 目测该功能已经下线
    {
      path: '/finance/batchCollectionRecord/batchCollectionRecordDetails',
      name: 'finance_batch_receivable_record_detail',
      component: () => import('@/pages/finance/CollectionRecordDetails'),
      meta: { title: '收款详情', logEvent: '' },
      hidden: true,
    },
    {
      path: '/finance/batchCollectionRecord/batchCollectionRecordDetailOnline',
      name: 'finance_batch_receivable_record_detail',
      component: () =>
        import('@/pages/finance/batchCollectionRecordDetailOnline'),
      meta: { title: '批量收款详情', logEvent: '' },
      hidden: true,
    },
    {
      path: '/finance/accountConfig',
      name: 'financeAccountConfig',
      component: () => import('@/pages/finance/accountConfig'),
      meta: { title: '财务账户配置', logEvent: '' },
    },
    {
      path: '/finance/accruedChange',
      name: 'financeAccruedChange',
      component: () => import('@/pages/finance/accruedChange'),
      meta: { title: '款项变更记录', logEvent: '' },
    },
    {
      path: '/finance/category',
      name: 'financeCategory',
      component: () => import('@/pages/finance/category'),
      meta: { title: '财务类目管理', logEvent: '' },
    },
    {
      path: '/finance/withholdPlanList',
      name: 'withholdPlanList',
      component: () => import('@/pages/finance/withholdPlanList/index'),
      meta: { title: '扣款计划管理', logEvent: '' },
    },
    {
      path: '/finance/payAccountConf',
      name: 'pay_account_conf',
      component: () => import('@/pages/finance/maintenance/payAccountConf/index'),
      meta: { title: '付款子户配置', logEvent: '' },
    },
    {
      path: '/finance/maintenanceBill',
      name: 'maintenance_bill',
      component: () => import('@/pages/finance/maintenance/maintenanceBill/index'),
      meta: { title: '维保对账单明细', logEvent: '' },
    },
    {
      path: '/finance/order_detail',
      name: 'order_detail',
      component: () => import('@/pages/finance/maintenance/maintenanceBill/detail'),
      meta: { title: '账单明细', logEvent: '' },
    },
    {
      path: '/finance/viewReceipts',
      name: 'withholdingCompanyConfigV1',
      component: () => import('@/pages/finance/viewReceipts/index.vue'),
      meta: { title: '代扣收款户查看', logEvent: '' },
    },
    {
      path: '/finance/maintenanceBindBankCard/bindBankCard',
      name: 'maintenanceBindBankCard',
      component: () =>
        import('@/pages/finance/walletWithholdConfig/bindBankCard/index.vue'),
      meta: { title: '绑定银行卡', logEvent: '' },
    },
    {
      path: '/finance/maintenanceReplaceBankCard/replaceBankCard',
      name: 'maintenanceReplaceBankCard',
      component: () =>
        import('@/pages/finance/walletWithholdConfig/bindBankCard/index.vue'),
      meta: { title: '更换银行卡', logEvent: '' },
    },
    {
      path: '/finance/entrustWithhold/contractTemplate',
      name: 'entrustWithholdContractTemplate',
      component: () =>
        import('@/pages/finance/entrustWithhold/index.vue'),
      meta: { title: '委托代扣合同模版', logEvent: '' },
    },
    //  预充值账户需求开发
    {
      path: '/finance/feeCenter/preChargeAccount',
      name: 'preChargeAccount',
      component: () => import('@/pages/finance/feeCenter/preChargeAccount/index.vue'),
      meta: { title: '预充值账户', logEvent: '' },
    },
    {
      path: '/finance/feeCenter/snapshotData',
      name: 'snapshotData',
      component: () =>
        import('@/pages/finance/feeCenter/snapshotData/index.vue'),
      meta: { title: '快照数据', logEvent: '' },
    },
  ],
}

export default home
